import React, { Component } from 'react';
import "./Form.scss";
import Carousel from "../Form/Carousel";
import { DomField, DomBoolCheckbox, DomCheckboxField, DomTextarea } from "../Services/formDOM";
import { checkInput, returnValue, hasValue, validateEmail } from "../Services/Validation";
import Popup from "../Popup/Popup";
import PopupMain from "../Popup/PopupMain";
import { scrollDown } from '../Services/scrollAnimation';
import { apiURL } from "../Services/Base";
import { GA_Push } from '../Services/GoogleAnalytics';

const throwPopupEvent = (obj) => {
    window.dispatchEvent(new CustomEvent("showpopup", {
        "detail": obj
    }));
}

Object.filter = function (obj, predicate) {
    var result = {}, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key) && predicate(obj[key])) {
            result[key] = obj[key];
        }
    }

    return result;
};
export default class Form extends Component {
    constructor(props) {
        super();
        this.state = {
            isBusy: false,
            isLoading: false,
            showHosting: false
        }
    }
    toggleHosting = () => {
        var res = this.state.showHosting;
        this.setState({ showHosting: !res });
    };
    handleInputChange = (event) => {
        const handleChange = {
            [event.target.name]: {
                ...this.state[event.target.name],
                error: "",
                label: event.target.dataset.label ? event.target.dataset.label : "",
                value: (event.target.dataset && event.target.dataset.bool === "true" ? (this.state[event.target.name].value ? 0 : 1) : event.target.value)
            }
        }
        this.setState(handleChange);
    }
    addState = (stateName, isRequired, stateId) => {
        this.setState({
            [stateName]: {
                name: stateName,
                value: "",
                label: "",
                id: stateId,
                isRequired: !isRequired ? false : true
            }
        })
    }
    setErrorMessage = (target, errorMsg) => {
        if (!this.state[target.name]) return;

        this.setState({
            [target.name]: {
                ...target,
                error: errorMsg
            }
        });
        scrollDown(".error", 150);

    }
    saveAndValidate = async () => {



        if (this.state.isBusy) return;

        this.setState({
            isLoading: true,
            isBusy: true
        });

        let isError = false,
            j = 0,
            jsonBody = {},
            state = Object.filter(this.state, s => s.isRequired),
            fieldStateKeys = Object.keys(state);



        for (let s in state) {
            if (await !checkInput(state[s], this.setErrorMessage)) isError = true;
            j++;
        }

        for (let k in fieldStateKeys) {
            jsonBody = Object.assign(jsonBody, {
                [fieldStateKeys[k]]: returnValue(state[fieldStateKeys[k]])
            });
        }

        let labels = "";
        for (let i = 1; i < 13; i++) {
            if (!this.state[`Family${i}`]) continue;
            if (this.state[`Family${i}`].value == 0) continue;
            labels += this.state[`Family${i}`].label + ",";
        }
        jsonBody = Object.assign(jsonBody, {
            Favorite: labels
        });


        if (isError && j == fieldStateKeys.length) {
            this.setState({
                isLoading: false,
                isBusy: false
            })
            return;
        }

        let isExists = await fetch(`${apiURL}IsExists`, {
            method: 'POST',
            headers: {
                'Content-Type': `application/json`
            },
            body: JSON.stringify(jsonBody)
        }).then(data => data.json());

        if (isExists) {
            throwPopupEvent({
                Type: "Message",
                ClassName: "success",
                refresh: false,
                Component: <Popup Context={`פרטים דומים רשומים כבר במאגר הנתונים`} />
            });
            return;
        }

        fetch(`${apiURL}Save`, {
            method: 'POST',
            headers: {
                'Content-Type': `application/json`
            },
            body: JSON.stringify(jsonBody)
        }).then(data => data.json())
            .then(data => {
                this.setState({
                    isLoading: false,
                    isBusy: false
                })
                GA_Push("Form_Sent");
                throwPopupEvent({
                    Type: "Message",
                    ClassName: "success",
                    refresh: true,
                    Component: <Popup Context={`פרטיך נשלחו בהצלחה!`} />
                });
            }).catch(error => {
                this.setState({
                    isLoading: false,
                    isBusy: false
                });
                throwPopupEvent({
                    Type: "Message",
                    ClassName: "success",
                    refresh: true,
                    Component: <Popup Context={`חלה שגיאה בעת שליחת הטופס`} />
                });
            });
    }
    render() {
        return (
            <div>
                <section className="section-form">

                    <div className="form">
                        <div className="title">
                            :מלאו את הפרטים הבאים
                        </div>

                        <div className="top-field">
                            <DomField
                                type="text"
                                max={64}
                                label="שם מלא"
                                placeholder="שם מלא"
                                name="FullName"
                                id="FullName"
                                className="field"
                                isRequired
                                onChange={this.handleInputChange}
                                onLoad={this.addState}
                                {...this.state} />

                            <DomField
                                type="text"
                                max={64}
                                label="כתובת"
                                placeholder="כתובת"
                                name="Address"
                                id="Address"
                                className="field"
                                isRequired
                                onChange={this.handleInputChange}
                                onLoad={this.addState}
                                {...this.state} />

                            <DomField
                                type="email"
                                max={20}
                                label='דוא"ל'
                                placeholder='דוא"ל'
                                name="Email"
                                id="Email"
                                className="field"
                                isRequired
                                onChange={this.handleInputChange}
                                onLoad={this.addState}
                                {...this.state} />

                            <DomField
                                type="tel"
                                max={10}
                                label="טלפון"
                                placeholder="טלפון"
                                name="PhoneNumber"
                                id="PhoneNumber"
                                className="field"
                                isRequired
                                onChange={this.handleInputChange}
                                onLoad={this.addState}
                                {...this.state} />
                        </div>

                        <div className="textarea-field">
                            <DomTextarea
                                type="text"
                                max={300}
                                label="ספרו לנו על עצמכם ו/או על המשפחה שלכם"
                                placeholder="ספרו לנו על עצמכם ו/או על המשפחה שלכם"
                                name="WhoAreYou"
                                id="WhoAreYou"
                                className="field"
                                isRequired
                                onChange={this.handleInputChange}
                                onLoad={this.addState}
                                {...this.state} />

                            <DomTextarea
                                type="text"
                                max={300}
                                label=" סוג המפגש אותו אתם מציעים כגון אירוח לארוחת ערב,בילוי עם הילדים,בילוי בבית קפה  וכד' "
                                placeholder="סוג המפגש אותו אתם מציעים כגון אירוח לארוחת ערב,בילוי עם הילדים,בילוי בבית קפה  וכד' "
                                name="EventType"
                                id="EventType"
                                className="field"
                                isRequired
                                onChange={this.handleInputChange}
                                onLoad={this.addState}
                                {...this.state} />
                            <DomTextarea
                                type="text"
                                max={300}
                                label="ספרו לנו למה אתם מעוניינים להשתתף בפעילות "
                                placeholder="ספרו לנו למה אתם מעוניינים להשתתף בפעילות "
                                name="WhyYou"
                                id="WhyYou"
                                className="field"
                                isRequired
                                onChange={this.handleInputChange}
                                onLoad={this.addState}
                                {...this.state} />

                        </div>

                        <div className="hosting-title" onClick={this.toggleHosting}>
                            <div className={`icon-${this.state.showHosting}`} ></div>
                            <div className="text">
                                (מבין המשתתפים בפרויקט ישנה עדיפות לארח את... (לא חובה
                            </div>



                        </div>


                        {
                            this.state.showHosting ?
                                (<div className="hosting-field">


                                    <DomBoolCheckbox
                                        type="checkbox"
                                        name="Family1"
                                        id="Family1"
                                        className="field"
                                        label="משפחת בראוון"
                                        value="משפחת בראוון"
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state}
                                    />


                                    <DomBoolCheckbox
                                        type="checkbox"
                                        name="Family2"
                                        id="Family2"
                                        className="field"
                                        label="אטנקוט סיטאוטאו"
                                        value="אטנקוט סיטאוטאו"
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state}
                                    />
                                    <DomBoolCheckbox
                                        type="checkbox"
                                        name="Family3"
                                        id="Family3"
                                        className="field"
                                        label="ניקולאס למפרט"
                                        value="ניקולאס למפרט"
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state}
                                    />


                                    <DomBoolCheckbox
                                        type="checkbox"
                                        name="Family4"
                                        id="Family4"
                                        className="field"
                                        label="משפחת קבסוב"
                                        value="משפחת קבסוב"
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state}
                                    />

                                    <DomBoolCheckbox
                                        type="checkbox"
                                        name="Family5"
                                        id="Family5"
                                        className="field"
                                        label="אנה גמזינובה"
                                        value="אנה גמזינובה"
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state}
                                    />

                                    <DomBoolCheckbox
                                        type="checkbox"
                                        name="Family6"
                                        id="Family6"
                                        className="field"
                                        label="משפחת פומרנץ-בן אבו"
                                        value="משפחת פומרנץ-בן אבו"
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state}
                                    />
                                    <DomBoolCheckbox
                                        type="checkbox"
                                        name="Family7"
                                        id="Family7"
                                        className="field"
                                        label="יונה וויסיד שניידר"
                                        value="יונה וויסיד שניידר"
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state}
                                    />
                                    <DomBoolCheckbox
                                        type="checkbox"
                                        name="Family8"
                                        id="Family8"
                                        className="field"
                                        label="האחים גלסורקר"
                                        value="האחים גלסורקר"
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state}
                                    />
                                    <DomBoolCheckbox
                                        type="checkbox"
                                        name="Family9"
                                        id="Family9"
                                        className="field"
                                        label="אלחנדרו מדפס"
                                        value="אלחנדרו מדפס"
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state}
                                    />
                                    <DomBoolCheckbox
                                        type="checkbox"
                                        name="Family10"
                                        id="Family10"
                                        className="field"
                                        label="אריק סרגון"
                                        value="אריק סרגון"
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state}
                                    />
                                    <DomBoolCheckbox
                                        type="checkbox"
                                        name="Family11"
                                        id="Family11"
                                        className="field"
                                        label="ג'רמי וסמנתה הריס"
                                        value="ג'רמי וסמנתה הריס"
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state}
                                    />
                                    <DomBoolCheckbox
                                        type="checkbox"
                                        name="Family12"
                                        id="Family12"
                                        className="field"
                                        label="משפחת טרסוב־בגליי"
                                        value="משפחת טרסוב־בגליי"
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state}
                                    />


                                </div>)
                                : null
                        }



                        <div className="title-slider">
                            :לפרטים אודות משתתפי הפעילות
                    </div>
                        <Carousel />



                        <div className="bottom-section">
                            <div className="terms">
                                <DomBoolCheckbox
                                    type="checkbox"
                                    name="Terms"
                                    id="Terms"
                                    className="field"
                                    label={' מאשר שקראתי את  <a href="https://z.ynet.co.il/mshort/commerce/api/tovshebatem/takanon.pdf" title="" target="_blank">התקנון</a>'}
                                    value="0"
                                    isRequired
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state}
                                />

                            </div>
                            <div className="button-send" onClick={this.saveAndValidate}>
                                <div className="text">
                                    שלח
                                </div>
                            </div>
                        </div>
                    </div>



                </section>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/Components/Form/Form.jsx